import { Select } from "antd";
import { ServiceProviderApiModel } from "@xemplo/types";
import { useGetServiceProvidersQueryV2 } from "@xemplo/directory-services-query";
import { useDebounceCallback } from "@xemplo/hooks";
import { useState } from "react";

type DirectoryServiceProviderLookupProps = {
  /** Injected by antd `getFieldDecorator` — the selected DS service provider id. */
  value?: number;
  /** Injected by antd `getFieldDecorator` — fires on selection change. */
  onChange?: (value: number) => void;
};

/** Single-select of an existing Directory Service provider (V2, server-side search). */
export const DirectoryServiceProviderLookup = ({
  value,
  onChange,
}: DirectoryServiceProviderLookupProps) => {
  const [searchTerm, setSearchTerm] = useState<string | undefined>(undefined);

  const { data, isLoading } = useGetServiceProvidersQueryV2({
    params: searchTerm?.trim() ? { searchTerm: searchTerm.trim() } : undefined,
  });

  const onSearch = useDebounceCallback(
    (term?: string) => setSearchTerm(term),
    300,
  );

  const handleChange = (selected: number) => {
    setSearchTerm(undefined);
    onChange?.(selected);
  };

  return (
    <Select
      placeholder="Select"
      onChange={handleChange}
      loading={isLoading}
      onSearch={onSearch}
      showSearch
      filterOption={false}
      value={value}
    >
      {data?.map((serviceProvider: ServiceProviderApiModel) => (
        <Select.Option key={serviceProvider.id} value={serviceProvider.id}>
          {serviceProvider.name} - {serviceProvider.id}
        </Select.Option>
      ))}
    </Select>
  );
};
